import React, {Component} from 'react';
import {connect} from 'react-redux';
import UniversalPopup from './UniversalPopup';
import { inject, observer } from 'mobx-react'

class PopupCompositor extends Component {
  render() {
    if(!this.props.show_popup) {
      return null;
    }
    switch(this.props.show_popup.type) {
      case "universal":
        return (
          <UniversalPopup data={this.props.show_popup.data} />
        );
      break;
    }
  }
}

function mapStateToProps(state) {
  return {
    show_popup:state.show_popup
  }
}

// export default connect(mapStateToProps)(PopupCompositor);
export default observer(PopupCompositor);
